<template>
  <section class="prizes__carousel">
    <div class="prizes-carousel generic-carousel">
      <div class="item" v-for="prize in getCarouselPrizes" :key="prize.type" style="cursor: pointer">
        <img class="jackpot_ribon" src="static/images/icon-ribbon-jackpot.png" />
        <img :src="prize.imgUrl" alt="">
        <span>{{ prize.headline }}</span>
      </div>
    </div>
    <div class="carousel__nav"></div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import 'owl.carousel';

export default {
  name: 'visitorPrizesCarousel',
  mounted() {
    this.$nextTick(() => {
      /*eslint-disable */
      // default home page carousel
      $('.prizes-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        dots: this.getCarouselPrizes.length > 1,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        navContainer: '.carousel__nav',
        dotsContainer: '.prizes__carousel__dots',
        navText: this.getCarouselPrizes.length > 1 ? ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'] : '',
        responsive: {
          0: {
            items: 1,
            nav: true
          }
        }
      });
    });
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/VisitorPrizesCarousel.vue